import { render, staticRenderFns } from "./segviacontratosp.vue?vue&type=template&id=4f42b39e"
import script from "./segviacontratosp.vue?vue&type=script&lang=js"
export * from "./segviacontratosp.vue?vue&type=script&lang=js"
import style0 from "./segviacontratosp.vue?vue&type=style&index=0&id=4f42b39e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports